import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { getLab } from "../../Functions/Laboratorio/get_lab_by_cnpj";
import { Health } from "../../Functions/gestao-produtos-laboratorios/health";
import { Relacionamento } from "../../Functions/gestao-laboratorios/relacionamento/otica";
import { mapeamento_laboratorio } from "../../Functions/Laboratorio/mapeamento_laboratorio";
import { get_configuracao_laboratorio_og } from "../../Functions/Laboratorio/get_configuracao_lab_og";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import Swal from "sweetalert2";
import AppContext from "../../appContext";

class RedirectPromo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labData: null,
			redirectPromo: false,
			redirectHome: false,
			cnpjLab: null,
			isLabOG: false,
		};

		RedirectPromo.contextType = AppContext;
	}

	async componentDidMount() {
		const { cnpj_lab, cnpj_otica, numero_cupom, total_pares, utilizar_cupom, identificacao_laboratorio } = this.props;
		this.context.showLoading();

		if (!this.context.userSession.modulos.includes("Pedidos")) {
			this.context.hideLoading();
			await this.showCouponModal(numero_cupom);
			return;
		}

		if (!cnpj_lab) {
			this.context.hideLoading();
			this.erroMessage("Erro ao processar cupom. CNPJ do laboratório não informado.");
			return;
		}

		const totalPares = total_pares || 1;

		let cnpjLabMapeado = cnpj_lab;
		let isLabOG = false;
		let labData = null;
		let nomeEmpresa = "";
		let cnpjEmpresa = cnpj_otica || this.context.userSession.conta;
		let configuracaoLabOG = null;

		try {
			const requestOptions = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ cnpj: cnpjEmpresa }),
			};

			const response = await fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions);
			const accountData = await response.json();

			if (accountData && accountData.nome) {
				nomeEmpresa = accountData.nome;
			} else {
				nomeEmpresa = "Ótica";
			}
		} catch (error) {
			nomeEmpresa = "Ótica";
		}

		const mapLab = await mapeamento_laboratorio(cnpj_lab);

		if (mapLab !== false) {
			cnpjLabMapeado = mapLab;

			try {
				const data = await getLab(cnpjLabMapeado);
				if (data !== false) {
					labData = data;
				} else {
					this.context.hideLoading();
					this.erroMessage("Não foi possível obter informações do laboratório.");
					return;
				}

				if (labData.item.Pedido === false) {
					this.context.hideLoading();
					await this.showCouponModal(numero_cupom);
					return;
				}
			} catch (error) {
				this.context.hideLoading();
				this.erroMessage("Não foi possível obter informações do laboratório.");
				return;
			}

			let isHealthy = await Health(cnpjLabMapeado);
			if (isHealthy === false) {
				this.context.hideLoading();
				this.erroMessage(
					"O serviço está temporariamente indisponível para este laboratório. O time do Essilor Conecta já está atuando para resolver o problema.",
				);
				return;
			}

			let relacionamento = await Relacionamento(cnpjLabMapeado, cnpj_otica);
			if (relacionamento === false) {
				this.context.hideLoading();
				this.erroMessage("Você não tem relacionamento com o laboratório informado no cupom.");
				return;
			}

			const segmentacao = this.context.userSession.segmentacao || "";
			const segmentosPermitidos = ["OTICA CAROL", "OTICAS CAROL", "CENTRO VISAO", "PREVENT", "LENS"];

			if (segmentosPermitidos.some(seg => segmentacao.toUpperCase().includes(seg))) {
				this.context.hideLoading();
				const continuar = await this.showCouponModalSegmentacao(numero_cupom);
				if (!continuar) {
					return;
				}
			}
		} else {
			isLabOG = true;
		}

		if (isLabOG) {
			configuracaoLabOG = await get_configuracao_laboratorio_og(cnpjLabMapeado);

			if (configuracaoLabOG !== undefined) {

				if (!configuracaoLabOG.laboratorioHabilitado) {
					this.context.hideLoading();

					if (utilizar_cupom) {
						await this.erroMessage("Este laboratório ainda não está habilitado a receber pedidos pelo Essilor Conecta.");
					} else {
						await this.showCouponModal(numero_cupom);
					}

					return;
				}

				if (!configuracaoLabOG.notificacoesConfigurada) {
					this.context.hideLoading();

					if (utilizar_cupom) {
						await this.erroMessage("Este laboratório ainda não possui canal de comunicação configurado para receber pedidos no Conecta.");
					} else {
						await this.showCupomNotificacoesNaoConfiguradas(numero_cupom);
					}

					return;
				}
			} else {
				this.erroMessage("Erro ao obter as configurações do laboratório.");
				return;
			}
			try {
				const ogLabData = await getLab(cnpj_lab);
				if (ogLabData !== false) {
					labData = ogLabData;
				}
			} catch (e) {
				console.warn("Aviso: Falha ao obter dados ogLabData (não crítico)", e);
			}
		}

		this.setState({
			cnpjLab: cnpjLabMapeado,
			labData: labData,
			isLabOG: isLabOG,
			nomeEmpresa: nomeEmpresa,
			cnpjEmpresa: cnpjEmpresa,
			totalPares: totalPares,
			identificacaoLaboratorio: identificacao_laboratorio,
			redirectPromo: true
		});

		this.context.hideLoading();
	}

	erroMessage(mensagem) {
		Swal.fire({
			html: mensagem,
			title: "Aviso",
			icon: "warning",
			showCancelButton: false,
			confirmButtonColor: "#3085d6",
			confirmButtonText: "Ok",
		}).then(() => {
			this.setState({ redirectHome: true });
		});
	}

	async showCupomNotificacoesNaoConfiguradas(codigo) {
		Swal.fire({
			title: "Pronto!",
			html: `
				<p>Este é o código do seu cupom Essilor Promo:</p>
				<input
					id="couponInput"
					value="${codigo}"
					readonly
					style="text-align: center; font-weight: bold; font-size: 18px; padding: 5px; border: 1px solid #ccc; border-radius: 5px; margin: 10px 0; width: 200px;"
				/>
				<p style="text-align: center; font-size: 18px; padding: 5px;">Este laboratório ainda não possui canal de comunicação configurado para receber pedidos no Conecta.</p>
			`,
			icon: "success",
			confirmButtonText: "Fechar",
			confirmButtonColor: "#3085d6",
		}).then(() => {
			this.setState({ redirectHome: true });
		});
	}

	async showCouponModalSegmentacao(codigo) {
		return new Promise((resolve) => {
			Swal.fire({
				title: "Pronto!",
				html: `
					<p>Este é o código do seu cupom Essilor Promo:</p>
					<input id="couponInput" value="${codigo}" readonly style="text-align: center; font-weight: bold; font-size: 18px; padding: 5px; border: 1px solid #ccc; border-radius: 5px; margin: 10px 0; width: 200px;" /><br><br>Deseja continuar a jornada dentro do Conecta Pedidos?
				`,
				icon: "success",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Sim",
				cancelButtonText: "Não",
			}).then(result => {
				if (result.value) {
					resolve(true);
				} else {
					this.setState({ redirectHome: true });
					resolve(false);
				}
			});
		});
	}

	async showCouponModal(codigo) {
		Swal.fire({
			title: "Pronto!",
			html: `
				<p>Este é o código do seu cupom Essilor Promo:</p>
				<input
					id="couponInput"
					value="${codigo}"
					readonly
					style="text-align: center; font-weight: bold; font-size: 18px; padding: 5px; border: 1px solid #ccc; border-radius: 5px; margin: 10px 0; width: 200px;"
				/>
			`,
			icon: "success",
			confirmButtonText: "Fechar",
			confirmButtonColor: "#3085d6",
		}).then(() => {
			this.setState({ redirectHome: true });
		});
	}


	render() {
		const { numero_cupom } = this.props;
		const { redirectPromo, labData, redirectHome, cnpjLab, isLabOG, nomeEmpresa, cnpjEmpresa, totalPares, identificacaoLaboratorio } = this.state;

		if (redirectHome) {
			return <Redirect to="/home" />;
		}

		if (redirectPromo) {
			const labInfo = labData ? {
				lab: cnpjLab || this.props.cnpj_lab,
				name: labData.item.labName,
				telefone: labData.item.labTelefone || "",
				site: labData.item.labSite || "",
				logo: labData.item.labLogo || null,
				email: labData.item.labEmail || "",
				IsCor_AR: labData.item.IsCor_AR || false,
				colorirNaOtica: labData.item.colorirNaOtica || false,
				CorteMontagemObrigatorio: labData.item.CorteMontagemObrigatorio || false,
				IsGrowmocao: labData.item.IsGrowmocao || false,
				IsPacto: labData.item.IsPacto || false,
				IsPactoNovaJornada: labData.item.PactoNovaJornada || false,
				corteRemoto: labData.item.corteRemoto || false,
				ArmacaoUsadaNova: labData.item.ArmacaoUsadaNova || false,
				IsPrismaAtivoPostural: labData.item.PrismaAtivoPostural || false,
				MontagemTipoArmacao: labData.item.MontagemTipoArmacao || false,
			} : {
				lab: cnpjLab || this.props.cnpj_lab,
				name: identificacaoLaboratorio?.nomeFantasia || CnpjUtils.formatCnpj(cnpjLab || this.props.cnpj_lab),
				telefone: "",
				site: "",
				logo: null,
				email: "",
				IsCor_AR: false,
				colorirNaOtica: false,
				CorteMontagemObrigatorio: false,
				IsGrowmocao: false,
				IsPacto: false,
				IsPactoNovaJornada: false,
				corteRemoto: false,
				ArmacaoUsadaNova: false,
				IsPrismaAtivoPostural: false,
				MontagemTipoArmacao: false,
			};

			return (
				<Redirect
					to={{
						pathname: "/order",
						state: {
							...labInfo,
							promo: true,
							promo_code: numero_cupom,
							promo_n_par: 1,
							promo_total_pares: totalPares,
							rastreabilidade: true,
							dados_empresa_faturamento_cnpj: cnpjEmpresa,
							dados_empresa_faturamento: nomeEmpresa,
							isLabOG: isLabOG,
							isPedidoPromocional: true,
						},
					}}
				/>
			);
		}

		return null;
	}
}

export default RedirectPromo;